module.exports = __webpack_public_path__ + "static/img/logo.178f2062.png";